import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MultiSelect = _resolveComponent("MultiSelect")!

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[1] || (_cache[1] = _createElementVNode("label", {
      for: "objeto-select",
      class: "form-label"
    }, "Motivo de Dispensa de Multa:", -1)),
    _createVNode(_component_MultiSelect, {
      modelValue: _ctx.selectedObjeto,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedObjeto) = $event)),
      options: _ctx.objeto,
      mode: "single",
      searchable: true,
      "close-on-select": true,
      valueProp: "valor",
      trackBy: "texto",
      label: "texto",
      placeHolder: "Selecione um Motivo de Dispensa de Multa",
      id: "item-select"
    }, null, 8, ["modelValue", "options"])
  ]))
}